import routes from '@modules/school/school-routes';
import store from '@modules/school/school-store';

export default {
    routes,
    store,
};